const facilities = [
  {
    name: "Bismarck Main Post Office",
    address: "220 E Rosser Ave, Bismarck, ND 58501",
    hours: "Mon–Fri 8:30am–5:00pm",
    phone: "(701) 221-6400",
    type: "Post Office",
    notes: "Primary passport acceptance facility for downtown Bismarck. Walk-ins accepted.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Bismarck South Post Office",
    address: "1640 E Divide Ave, Bismarck, ND 58501",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(701) 258-2341",
    type: "Post Office",
    notes: "Convenient for south Bismarck and suburban residents.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Burleigh County Clerk of Courts",
    address: "514 E Thayer Ave, Bismarck, ND 58501",
    hours: "Mon–Fri 8:00am–5:00pm",
    phone: "(701) 222-6690",
    type: "County Clerk",
    notes: "Downtown Bismarck — accepts passport applications. ID required.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Mandan Post Office",
    address: "300 W Main St, Mandan, ND 58554",
    hours: "Mon–Fri 9:00am–5:00pm",
    phone: "(701) 663-3481",
    type: "Post Office",
    notes: "Serves Mandan and west bank Missouri River communities.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Lincoln Post Office",
    address: "4585 Lincoln Rd, Lincoln, ND 58504",
    hours: "Mon–Fri 9:00am–12:00pm, 1:00–5:00pm",
    phone: "(701) 258-5437",
    type: "Post Office",
    notes: "Convenient for Lincoln and southeast Bismarck area residents.",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Washburn Post Office",
    address: "19 Main St, Washburn, ND 58577",
    hours: "Mon–Fri 8:30am–4:30pm",
    phone: "(701) 462-3346",
    type: "Post Office",
    notes: "Serves north central Burleigh County and McLean County border communities.",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit Passport Applications in Bismarck
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the passport acceptance facilities serving Bismarck and the surrounding Burleigh County area. Fast Passport Center will guide you to exactly the right one.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className={`${f.type === "Post Office" ? "ri-mail-line" : "ri-building-2-line"} text-[#1A365D]`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <span className="text-xs text-gray-400 font-medium">{f.type}</span>
                </div>
              </div>
              <ul className="space-y-2 text-sm text-gray-500 flex-1">
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.address}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.hours}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  {f.phone}
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </li>
                <li className="flex items-start gap-2 pt-2 border-t border-gray-100 text-gray-400 italic">
                  <i className="ri-information-line text-gray-300 flex-shrink-0 mt-0.5"></i>
                  {f.notes}
                </li>
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-7 text-center">
          <h3 className="font-bold text-white text-lg mb-2">Not Sure Which Facility to Use?</h3>
          <p className="text-white/60 text-sm mb-5">
            Fast Passport Center will tell you exactly which acceptance facility is best for your Bismarck location and schedule — and precisely what to bring.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            Get Personalized Guidance <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}